import {
  ActionIcon,
  AppShell,
  Burger,
  Group,
  Image,
  rem,
  Stack,
  useComputedColorScheme,
  useMantineColorScheme
} from "@mantine/core"
import { useDisclosure, useLocalStorage } from "@mantine/hooks"
import { IconMoon, IconSun } from "@tabler/icons-react"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Outlet, ScrollRestoration } from "react-router"
import { LanguagePicker } from "./Components/LanguagePicker/LanguagePicker"

import classes from "./App.module.css"

function App() {
  const { i18n } = useTranslation()

  const [opened, { toggle }] = useDisclosure()
  const [language, setLanguage] = useLocalStorage<string>({
    key: "language",
    defaultValue: "en"
  })

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  const { toggleColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme("light", {
    getInitialValueInEffect: true
  })

  return (
    <AppShell
      header={{ height: rem(60), offset: true }}
      navbar={{ width: 300, breakpoint: "sm", collapsed: { desktop: true, mobile: !opened } }}
      transitionDuration={200}
      transitionTimingFunction="ease"
      withBorder={false}
    >
      <AppShell.Header className={classes.header}>
        <Group p={"xs"} align={"center"} justify="space-between" maw={rem(1440)} mx="auto">
          <Group>
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" aria-label="nav-toggle" />
            <ActionIcon
              variant={"transparent"}
              color={"dimmed"}
              radius={0}
              onClick={() => open("https://auroraoss.com", "_self")}
            >
              <Image h={24} w={"auto"} alt="logo" src={"/favicon.svg"} />
            </ActionIcon>
          </Group>

          <Group justify="flex-end" align="center" gap={"sm"}>
            <LanguagePicker currentLanguage={language} onChange={(language: any) => setLanguage(language.code)} />

            <ActionIcon
              size={rem(36)}
              variant="default"
              onClick={() => toggleColorScheme()}
              aria-label="toggle-color-scheme"
            >
              {computedColorScheme === "dark" ? (
                <IconMoon size={20} stroke={1.5} />
              ) : (
                <IconSun size={20} stroke={1.5} />
              )}
            </ActionIcon>
          </Group>
        </Group>
      </AppShell.Header>

      <AppShell.Navbar>
        <Stack gap={rem(6)}></Stack>
      </AppShell.Navbar>

      <AppShell.Main className={classes.content}>
        <ScrollRestoration />
        <Outlet />
      </AppShell.Main>
    </AppShell>
  )
}

export default App
